import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Image } from "react-bootstrap";

import { CustomAd } from "../../utils/interface";
import { Config } from "../../common";

interface Props {
  adData: CustomAd | null;
  onSubmit: (customAdId: number, formData: FormData) => void;
}

const UpdateCustomAd: React.FC<Props> = ({
  adData,
  onSubmit,
}) => {
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const onClose = () => setShowModal(false);

  // Load existing ad when modal opens
  useEffect(() => {
    if (adData) {
      setImagePreview(`${Config.server.baseUrl}/${adData.contentLocation}`);  // default old image
      setImageFile(null);
    }
  }, [adData]);

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = () => {
    if (!adData) return;

    const formData = new FormData();
    if (imageFile) {
      formData.append("contentLocation", imageFile);   // only append if changed
    }

    onSubmit(adData.customAdId, formData);
    onClose();
  };

  return (<>
      <Button
        variant="info"
        size="sm"
        className="me-2"
        onClick={() => setShowModal(true)}
        >
        Edit
      </Button>
    <Modal show={showModal} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Advertisement</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!adData ? (
          <p className="text-center text-muted">Loading...</p>
        ) : (
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Change Image (optional)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
            </Form.Group>

            {imagePreview && (
              <div className="text-center mb-3">
                <Image
                  src={imagePreview}
                  thumbnail
                  height={140}
                  style={{ objectFit: "cover" }}
                />
              </div>
            )}
          </Form>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSubmit} disabled={!adData}>
          Update Ad
        </Button>
      </Modal.Footer>
    </Modal>
  </>);
};

export default UpdateCustomAd;
